/**
 * The picker's location chip (#6559 round 17, Claude Design ruling D): under
 * the title, above the scope group, it names where the reader is — "All
 * drives and apps" at the root, the place once inside one — and its menu
 * jumps between places for readers who know the destination. The rows do
 * the same by clicking; the chip is the shortcut.
 */
import React, { useState } from "react";
import { CaretDownIcon, HardDrivesIcon } from "@phosphor-icons/react";
import { Menu } from "@/components/FpPages/RMS/design";

export interface LocationChipItem {
  key: string;
  label: string;
  onSelect: () => void;
}

const LocationChip: React.FC<{
  label: string;
  items: LocationChipItem[];
}> = ({ label, items }) => {
  const [anchor, setAnchor] = useState<HTMLElement | null>(null);
  return (
    <>
      <button
        type="button"
        aria-label={`Location: ${label}`}
        aria-haspopup="menu"
        aria-expanded={anchor !== null}
        onClick={(event) => setAnchor(event.currentTarget)}
        className="inline-flex h-[24px] shrink-0 items-center gap-1.5 rounded-[6px] border border-[var(--fp-border-strong)] bg-[var(--fp-surface)] px-2 text-[12px] font-medium text-[var(--fp-ink)] shadow-[var(--fp-lift)] hover:border-[var(--fp-ink-3)]"
      >
        <HardDrivesIcon
          size={13}
          aria-hidden
          className="text-[var(--fp-ink-3)]"
        />
        <span className="max-w-[220px] truncate">{label}</span>
        <CaretDownIcon size={10} weight="bold" aria-hidden />
      </button>
      <Menu
        anchorEl={anchor}
        open={anchor !== null}
        onClose={() => setAnchor(null)}
        label="Location"
        items={items.map((item) => ({
          label: item.label,
          onSelect: () => {
            setAnchor(null);
            item.onSelect();
          },
        }))}
      />
    </>
  );
};

export default LocationChip;
